// extracted by mini-css-extract-plugin
export default {"container":"form-group_container__oV6bG","label":"form-group_label__wxR5u","fieldsetContent":"form-group_fieldsetContent__d1wFj"};